import { render, staticRenderFns } from "./product-nav.vue?vue&type=template&id=1b44ac59&scoped=true"
import script from "./product-nav.vue?vue&type=script&lang=js"
export * from "./product-nav.vue?vue&type=script&lang=js"
import style0 from "./product-nav.vue?vue&type=style&index=0&id=1b44ac59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b44ac59",
  null
  
)

export default component.exports